import React from 'react';
import {
    SequenceMatchType,
    SpecTableChecked,
    SpecTableResults,
    TokenMatchType,
} from '../types'; // Removed unused import 'MatchSequence'
import Tooltip from '@mui/material/Tooltip';

interface SpecCheckDetailsTableProps {
    specTableResults: SpecTableResults;
}

const SpecCheckDetailsTableNew: React.FC<SpecCheckDetailsTableProps> = ({
    specTableResults,
}) => {
    return (
        <>
            <table className="spec-check-details-table">
                <tr className="header">
                    {specTableResults.headers.map((header, i) => (
                        <td key={i}>
                            {header.checked_tokens.map((token, j) => {
                                if (
                                    token.token_match_type ===
                                    TokenMatchType.FULL_MATCH
                                ) {
                                    return (
                                        <span key={j}>
                                            {token.pack_copy_token?.text}
                                        </span>
                                    );
                                } else {
                                    return (
                                        <>
                                            <Tooltip
                                                title={
                                                    <p
                                                        style={{
                                                            margin: '0px',
                                                            fontSize: '1.4em',
                                                        }}
                                                    >
                                                        {`Remove "${token.label_token?.text}"`}
                                                    </p>
                                                }
                                                placement="top"
                                                arrow={true}
                                            >
                                                <span
                                                    key={`${j}.1`}
                                                    className="red"
                                                >
                                                    {token.label_token?.text}
                                                </span>
                                            </Tooltip>
                                            <Tooltip
                                                title={
                                                    <p
                                                        style={{
                                                            margin: '0px',
                                                            fontSize: '1.4em',
                                                        }}
                                                    >
                                                        {`Add "${token.pack_copy_token?.text}"`}
                                                    </p>
                                                }
                                                placement="top"
                                                arrow={true}
                                            >
                                                <span
                                                    key={`${j}.2`}
                                                    className="green"
                                                >
                                                    {
                                                        token.pack_copy_token
                                                            ?.text
                                                    }
                                                </span>
                                            </Tooltip>
                                        </>
                                    );
                                }
                            })}
                        </td>
                    ))}
                </tr>
                {specTableResults.rows.map((row, i) => (
                    <tr key={i}>
                        {row.map((matchSequence, k) => (
                            <td key={k}>
                                {matchSequence !== null
                                    ? matchSequence.checked_tokens.map(
                                          (checkedToken, j) => {
                                              if (
                                                  checkedToken.token_match_type ===
                                                  TokenMatchType.FULL_MATCH
                                              ) {
                                                  return (
                                                      <span key={j}>
                                                          {
                                                              checkedToken
                                                                  .pack_copy_token
                                                                  ?.text
                                                          }
                                                      </span>
                                                  );
                                              } else {
                                                  return (
                                                      <>
                                                          <Tooltip
                                                              title={
                                                                  <p
                                                                      style={{
                                                                          margin: '0px',
                                                                          fontSize:
                                                                              '1.4em',
                                                                      }}
                                                                  >
                                                                      {`Remove "${checkedToken.label_token?.text}"`}
                                                                  </p>
                                                              }
                                                              placement="top"
                                                              arrow={true}
                                                          >
                                                              <span
                                                                  key={`${j}.1`}
                                                                  className="red"
                                                              >
                                                                  {
                                                                      checkedToken
                                                                          .label_token
                                                                          ?.text
                                                                  }
                                                              </span>
                                                          </Tooltip>
                                                          <Tooltip
                                                              title={
                                                                  <p
                                                                      style={{
                                                                          margin: '0px',
                                                                          fontSize:
                                                                              '1.4em',
                                                                      }}
                                                                  >
                                                                      {`Add "${checkedToken.pack_copy_token?.text}"`}
                                                                  </p>
                                                              }
                                                              placement="top"
                                                              arrow={true}
                                                          >
                                                              <span
                                                                  key={`${j}.2`}
                                                                  className="green"
                                                              >
                                                                  {
                                                                      checkedToken
                                                                          .pack_copy_token
                                                                          ?.text
                                                                  }
                                                              </span>
                                                          </Tooltip>
                                                      </>
                                                  );
                                              }
                                          },
                                      )
                                    : null}
                            </td>
                        ))}
                    </tr>
                ))}
            </table>
        </>
    );
};

export default SpecCheckDetailsTableNew;
